var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowTopMiddle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "179px",
    height: "179px",
    viewBox: "0 0 179 179",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pixagri",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Aide-4",
    transform: "translate(-586.000000, -166.000000)",
    stroke: "#9EBE4A",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(675.163592, 255.808127) rotate(-47.000000) translate(-675.163592, -255.808127) translate(612.832612, 196.119377)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Line-21",
    strokeLinejoin: "round",
    transform: "translate(3.387720, 67.209621) rotate(-183.000000) translate(-3.387720, -67.209621) ",
    points: "0.166355801 63.9466522 6.397721 63.9934749 6.60908432 70.4725889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9654936,18.664218 C21.9894379,35.925979 33.0330952,62.5102489 53.2949666,80.4166704 C66.8028809,92.3542847 85.6403822,99.1198217 109.80747,100.713281",
    id: "Line-8",
    transform: "translate(63.386482, 59.688750) scale(1, -1) rotate(-33.000000) translate(-63.386482, -59.688750) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTopMiddle);
export default __webpack_public_path__ + "static/media/arrow_top_middle.e3a987a5.svg";
export { ForwardRef as ReactComponent };